import classNames from 'classnames'
import Text from '../Common/NewText'

type Tprops = {
  returnsData: {
    absoluteReturn?: number
    absoluteReturnPercentage?: number
    returnTxt?: string
  }
  addClassName?: string
}
const ReturnsData = ({ returnsData, addClassName }: Tprops) => {
  const {
    absoluteReturn = null,
    absoluteReturnPercentage,
    returnTxt,
  } = returnsData ?? {}

  if (absoluteReturn === null || typeof absoluteReturn !== 'number') return null

  const returnArrow = absoluteReturn >= 0 ? '+' : ''

  return (
    <div
      className={classNames(
        'flex w-full flex-row flex-wrap items-center gap-x-1',
        {
          [addClassName ?? '']: addClassName,
        },
      )}
    >
      <Text
        appearance="subtitle2"
        addClassName={classNames({
          'text-brand-green-dark': absoluteReturn >= 0,
          'text-brand-red-cinnabar': absoluteReturn < 0,
        })}
      >
        {returnArrow}
        {absoluteReturn.toFixed(2)}
      </Text>
      <Text
        appearance="subtitle2"
        addClassName={classNames({
          'text-brand-green-dark': absoluteReturn >= 0,
          'text-brand-red-cinnabar': absoluteReturn < 0,
        })}
      >
        {absoluteReturnPercentage &&
          `(${returnArrow}${absoluteReturnPercentage.toFixed(2)}%)`}{' '}
      </Text>
      {returnTxt && (
        <Text appearance="caption" addClassName="text-brand-grey-base">
          {returnTxt}
        </Text>
      )}
    </div>
  )
}

export default ReturnsData
